import { Injectable, OnDestroy } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class Five9StylingService implements OnDestroy {
	private handler = this.handleMessage.bind(this);
	private listenerAdded = false;
	private observer: MutationObserver | null = null;

	public enableNarrowMinimizedButton(): void {
		if (!this.listenerAdded) {
			window.addEventListener('message', this.handler);
			this.listenerAdded = true;
		}

		if (!this.observer) {
			this.observer = new MutationObserver((mutations) => {
				for (const mutation of mutations) {
					if (mutation.addedNodes.length > 0) {
						for (const node of Array.from(mutation.addedNodes)) {
							if (node.nodeType === Node.ELEMENT_NODE) {
								const element = node as Element;
								if (
									element.classList?.contains('five9-frame') ||
									element.querySelector('.five9-frame')
								) {
									this.applyCorrectWidth();
									return;
								}
							}
						}
					}
				}
			});

			this.observer.observe(document.body, { childList: true, subtree: true });
		}

		// Fallback immediate check
		requestAnimationFrame(() => this.applyCorrectWidth());
	}

	public disableNarrowMinimizedButton(): void {
		this.restoreDefaultWidth();
		this.observer?.disconnect();
		this.observer = null;
	}

	private handleMessage(event: MessageEvent): void {
		if (typeof event.data !== 'string') return;
		try {
			const msg = JSON.parse(event.data);
			if (msg?.action === 'minimize') {
				this.applyNarrowWidth();
			}
		} catch {
			/* JSON parse failed, ignore non-JSON messages */
		}
	}

	private applyCorrectWidth(): void {
		const frame = document.querySelector('.five9-frame') as HTMLElement;
		if (!frame) return;

		const minimized = frame.querySelector('.five9-frame-minimized') as HTMLElement;
		const isMinimized = minimized && getComputedStyle(minimized).display !== 'none';

		if (isMinimized) {
			this.applyNarrowWidth();
		} else {
			this.restoreDefaultWidth();
		}
	}

	private applyNarrowWidth(): void {
		const frame = document.querySelector('.five9-frame') as HTMLElement;
		const header = document.querySelector('.five9-header') as HTMLElement;

		if (frame) {
			frame.style.cssText = `
			  width: 90px !important;
			  min-width: 90px !important;
			  max-width: 90px !important;
			  right: 300px !important;
			  text-align: center !important;
			`;
		}

		if (header) {
			header.style.cssText = 'width:90px !important; min-width:90px !important; max-width:90px !important;';
		}
	}

	private restoreDefaultWidth(): void {
		const frame = document.querySelector('.five9-frame') as HTMLElement;
		const header = document.querySelector('.five9-header') as HTMLElement;

		if (frame) {
			frame.style.cssText = ''; // removes all inline styles → falls back to original right:10%
		}
		if (header) {
			header.style.cssText = '';
		}
	}

	ngOnDestroy(): void {
		window.removeEventListener('message', this.handler);
		this.observer?.disconnect();
	}
}
